import type { SVGProps } from 'react';

export const ArchitectureIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 48 48"
    width="1em"
    height="1em"
    {...props}
  >
    <mask
      id="a"
      width="48"
      height="48"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'alpha' }}
    >
      <path fill="currentColor" d="M0 0h48v48H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="currentColor"
        d="m13.854 40.923-.354-2.434L19.407 22.2c.29.264.603.484.937.66.335.175.688.32 1.06.436l-5.746 15.873-1.804 1.754Zm20.292 0-1.803-1.754-5.809-15.823c.36-.128.715-.277 1.066-.446a3.73 3.73 0 0 0 .961-.669L34.5 38.489l-.354 2.434ZM24 21.5c-1.526 0-2.824-.535-3.894-1.606-1.07-1.07-1.606-2.368-1.606-3.894 0-1.374.415-2.558 1.244-3.552.83-.994 1.87-1.596 3.122-1.806V6h2.268v4.643c1.252.21 2.292.811 3.122 1.805.83.994 1.244 2.178 1.244 3.552 0 1.526-.535 2.824-1.606 3.894-1.07 1.07-2.368 1.606-3.894 1.606Zm0-2.269c.897 0 1.66-.314 2.288-.943.629-.628.943-1.39.943-2.288 0-.897-.314-1.66-.943-2.289-.628-.628-1.39-.942-2.288-.942-.897 0-1.66.314-2.288.942-.629.629-.943 1.392-.943 2.289 0 .897.314 1.66.943 2.288.628.629 1.39.943 2.288.943Z"
      />
    </g>
  </svg>
);
